module.exports = __webpack_public_path__ + "img/valuable-items.d662734b.png";